/* Shorebird v2: scroll-snap carousel with prev/next buttons */
(function () {
  if (customElements.get('s2-carousel')) return;
  customElements.define('s2-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-s2-track]');
      if (!this.track) return;
      this.prev = this.querySelector('[data-s2-prev]');
      this.next = this.querySelector('[data-s2-next]');
      var self = this;
      function step(dir) {
        var first = self.track.firstElementChild;
        var gap = parseFloat(getComputedStyle(self.track).columnGap) || 0;
        var amount = first ? first.getBoundingClientRect().width + gap : self.track.clientWidth;
        self.track.scrollBy({ left: dir * amount, behavior: 'smooth' });
      }
      if (this.prev) this.prev.addEventListener('click', function () { step(-1); });
      if (this.next) this.next.addEventListener('click', function () { step(1); });
      this.update = function () {
        var max = self.track.scrollWidth - self.track.clientWidth - 2;
        if (self.prev) self.prev.disabled = self.track.scrollLeft <= 2;
        if (self.next) self.next.disabled = self.track.scrollLeft >= max;
      };
      this.track.addEventListener('scroll', this.update, { passive: true });
      window.addEventListener('resize', this.update);
      this.update();
    }
    disconnectedCallback() {
      if (this.update) window.removeEventListener('resize', this.update);
    }
  });
})();